<template>
  <div class="sortingcenter">
    <div class="bg-white sortingcenter-list pl32 pr32 pt32">
      <h4 class="sortingcenter-list-title">
        <div></div>
        大件回收订单列表
      </h4>

      <a-table
        :columns="columns"
        :dataSource="backEndList"
        :rowKey="(record) => record.id"
        bordered
        class="mt24"
        :pagination="pagination"
        @change="pageChange"
      >
        <template slot="operation" slot-scope="text, record">
          <a class="btn btn_text" @click="detailsClick(text)">查看详情</a>
        </template>
      </a-table>
    </div>
  </div>
</template>
  <script>
export default {
  name: "sortingcenter",
  data() {
    return {
      form: {},
      columns: [
        {
          title: "订单编号",
          dataIndex: "serial",
          key: "serial",
        },
        {
          title: "回收人员",
          dataIndex: "recycling_name",
          key: "recycling_name",
        },
        {
          title: "品类种类",
          dataIndex: "second_name",
          key: "second_name",
        },
        {
          title: "毛重(公斤)",
          dataIndex: "total_weight",
          key: "total_weight",
        },
        {
          title: "皮重(公斤)",
          dataIndex: "actual_weight",
          key: "actual_weight",
        },

        {
          title: "净重(公斤)",
          dataIndex: "weight_amount",
          key: "weight_amount",
        },
        {
          title: "分拣中心",
          dataIndex: "sorting_name",
          key: "sorting_name",
        },
        {
          title: "操作",
          dataIndex: "",
          scopedSlots: { customRender: "operation" },
        },
      ],
      pagination: {
        //默认当前页
        defaultCurrent: 1,
        defaultPageSize: 10,
        showTotal() {
          return `共 ${this.total} 条数据`;
        },
        showSizeChanger: true,
        total: 0,
      },
      page: 1,
      page_num: 10,
      backEndList: [],
    };
  },
  created() {
    this.getFrontEndList();
  },
  components: {},
  mounted() {},
  methods: {
    // 大件回收订单 --> 查看详情
    detailsClick(row) {
      console.log(row);
      this.$router.push({
        name: "PossessionDetails",
        query: {
            serial: row.serial,
        },
      });
    },
    // 头部数据重置
    reset() {
      this.page = 1;
      this.page_num = 10;
      this.$set(this.pagination, "current", 1);
      this.$set(this.pagination, "pageSize", 10);
      this.form = {};
      this.getFrontEndList();
    },
    //查询
    search() {
      this.$set(this.pagination, "current", 1);
      this.$set(this.pagination, "pageSize", 10);
      this.page = 1;
      this.page_num = 10;
      this.getFrontEndList(true);
    },

    //获得获取订单列表
    //page:页 page_num每页条数
    getFrontEndList(status = false) {
      this.form.page = this.page;
      this.form.limit = this.page_num;
      this.$api.account.bigOrderList(this.form).then((res) => {
        this.pagination.total = res.total * 1;
        res.data.list.forEach((el, index) => {
          el.id = index;
        });
        this.backEndList = res.data.list;
        status ? this.$message.success("共查询到" + res.total + "条信息") : "";
      });
    },
    // 分页
    pageChange(pagination) {
      this.$set(this.pagination, "current", pagination.current);
      this.$set(this.pagination, "pageSize", pagination.pageSize);
      this.page = pagination.current;
      this.page_num = pagination.pageSize;
      this.getFrontEndList();
    },
  },
};
</script>
  <style rel="stylesheet/scss" lang="scss">
.sortingcenter {
  &-data {
    &-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .title {
        display: flex;
        align-items: center;
        color: $title-color-black-85;
        @include pxAndLh(16);
        font-weight: bold;
        margin: 0;
        & > div {
          width: 5px;
          height: 20px;
          background: linear-gradient(180deg, #3f94ec 0%, #0c6ecf 100%);
          border-radius: 5px;
          margin-right: 5px;
        }
      }
      .search {
        display: flex;
        align-items: center;
      }
    }
    &-content {
      &-item {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        font-size: 14px;
        .item {
          margin-right: 70px;
          margin-top: 10px;
          .name {
            color: #858a90;
          }
          .data {
            color: #363e51;
            font-weight: 600;
          }
          & > div {
            text-align: center;
          }
        }
      }
    }
  }
  &-list {
    &-title {
      display: flex;
      align-items: center;
      color: $title-color-black-85;
      @include pxAndLh(16);
      font-weight: bold;
      margin: 0;
      & > div {
        width: 5px;
        height: 20px;
        background: linear-gradient(180deg, #3f94ec 0%, #0c6ecf 100%);
        border-radius: 5px;
        margin-right: 5px;
      }
    }
    &-search {
      display: flex;
    }
  }
}
</style>